import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getMainAgentReport=({
    startDate,
    endDate,
    type
})=>async dispatch=>{
    dispatch({
        type:actionTypes.MAIN_AGENT_REPORT_START,
    })
    await axios.get(`/reports/agents?startDate=${startDate}&endDate=${endDate}&type=${type}`)
            .then(response=>dispatch({
                type:actionTypes.MAIN_AGENT_REPORT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.MAIN_AGENT_REPORT_FAIL,
                payload:getMessage(error)
            }))
}